/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import { ucwords } from '../../../../../applications/helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function CreateRangeModal({
  newBusinessesId,
  createNewBusinessActivities,
  getSingleNewBusinesses,

  getBusinessLinesList,
  businessLinesList,

  getNecessaryFieldsList,
  necessaryFieldsList,
  creating,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    business_line_id: '',
    capital_amount: '',
    gross_amount: '',
  });
  const commonValidation = {
    business_line_id: 'required',
    capital_amount: 'required|number',
    gross_amount: 'required|number',
  };

  const [formDetails, setFormDetails] = useState({});
  const [multiplierData, setMultiplierData] = useState({});
  const validateForm = useFormValidator(formData, commonValidation);
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});
  const filteredNecessaryFieldsList = necessaryFieldsList.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = necessaryFieldsList.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );

  useEffect(() => {
    getBusinessLinesList();
    setFormData({
      business_line_id: '',
      capital_amount: '',
      gross_amount: '',
      details: {},
    });
  }, []);

  const validateMultiplier = Object.keys(formDetails || {})
    .map((item) => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateMultiplier = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateMultiplier) {
      setMultiplierData((prevData) => ({
        ...prevData,
        ...value,
      }));
    }
  };

  const validateFormMultiplier = useFormValidator(formDetails, multiplierData);

  useEffect(() => {
    setValidateMultiplier();
  }, [formDetails, _.get(formData, 'business_line_id')]);

  useEffect(() => {
    validateFormMultiplier.onSetObjectRules(multiplierData);
  }, [multiplierData, formDetails]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const combinedDetails = {
      ...formDetails,
      quantity_matrix: formDataQuantityMatrix,
    };

    const args = {
      business_line_id: _.get(formData, 'business_line_id'),
      capital_amount: +_.get(formData, 'capital_amount'),
      gross_amount: +_.get(formData, 'gross_amount'),
      details: combinedDetails,
    };

    createNewBusinessActivities(newBusinessesId, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(newBusinessesId);
      setFormData({});
      setFormDataQuantityMatrix({});
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleLineDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    setFormDetails();

    const args = {
      business_line_id: e ? e.value : '',
      application_status_id: 0,
    };

    getNecessaryFieldsList(args);
  };

  const onSelectDetails = (key) => (e) => {
    setFormDetails({
      ...formDetails,
      [key]: e ? e.value : '',
    });
  };

  const onChangeQuantityMatrix = (e) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [e.target.name]: e ? +e.target.value : '',
    });
  };

  const selectBusinessLineId = businessLinesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const selectOptions = (list) => {
    const newList = [];

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  useEffect(() => {
    if (!formDetails) return;
    const calculateTotalGrossAmount = () => {
      if (!formDetails) return 0;

      return Object.keys(formDetails)
        .filter((key) => key.includes('gross_amount'))
        .reduce((total, key) => {
          const amount = parseFloat(formDetails[key]) || 0;
          return total + amount;
        }, 0);
    };

    setFormData({
      ...formData,
      gross_amount:
        calculateTotalGrossAmount() || _.get(formData, 'gross_amount'),
    });
  }, [JSON.stringify(formDetails)]);

  useEffect(() => {
    validateFormMultiplier.validate();
  }, [
    Object.keys(formDetails || {}).join(','),
    Object.values(formDetails || {}).join(','),
  ]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  const hasGrossAmount = necessaryFieldsList.some((item) =>
    _.get(item, 'multiplier', '').includes('gross_amount')
  );

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Business Line: {validateForm.renderMessage('business_line_id')}
            </label>
            <Select
              options={selectBusinessLineId}
              placeholder="Select Business Line"
              onChange={handleLineDropDownChange('business_line_id')}
              isClearable
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Capital Amount: {validateForm.renderMessage('capital_amount')}
            </label>
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                setFormData({
                  ...formData,
                  capital_amount: value,
                });
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'capital_amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Gross Amount: {validateForm.renderMessage('gross_amount')}
            </label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                setFormData({
                  ...formData,
                  gross_amount: value,
                });
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'gross_amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
              disabled={hasGrossAmount}
            />
          </div>
          <div className="col-12 form-group">
            {(filteredNecessaryFieldsList || [])?.map((item) => {
              const multiplier = _.get(item, 'multiplier', '');
              const options = _.get(item, 'options');
              const label = ucwords(multiplier?.replace(/_/g, ' '));
              const validationMsg =
                validateFormMultiplier.renderMessage(multiplier);
              const hasGrossKey = multiplier.includes('gross_amount_');

              if (options) {
                return (
                  <React.Fragment key={multiplier}>
                    <label className="form-label">
                      {label} {validationMsg}
                    </label>
                    <Select
                      onChange={onSelectDetails(multiplier)}
                      options={selectOptions(options)}
                      isClearable
                    />
                  </React.Fragment>
                );
              }

              return (
                <React.Fragment key={multiplier}>
                  <label className="form-label">
                    {label} {validationMsg}
                  </label>

                  <NumberFormat
                    name={multiplier}
                    id={multiplier}
                    placeholder="0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { value } = values;
                      setFormDetails({
                        ...formDetails,
                        [multiplier]: value,
                      });
                    }}
                    displayType="input"
                    decimalScale={2}
                    isNumericString
                    allowNegative
                    thousandSeparator
                    allowLeadingZeros
                    prefix={hasGrossKey ? '₱ ' : ''}
                    value={_.get(formData, multiplier)}
                    isAllowed={(values) => {
                      const { value } = values;
                      if (!hasGrossKey || !value) return true;
                      const val = new Decimal(value);
                      const max = new Decimal(MAX_LIMIT);
                      return value === undefined || val.lte(max);
                    }}
                  />
                </React.Fragment>
              );
            })}
          </div>
          {!_.isEmpty(filteredQuantityMatrix) ? (
            filteredQuantityMatrix.map((item) => {
              const multiplier = _.get(item, 'multiplier', '');
              
              return (
                <React.Fragment>
                  <div className='form-group col-12 mb-0'>
                    <label className='form-label mb-0 text-capitalize'>
                      {multiplier}
                    </label>
                  </div>
                  <div className="w-100 border rounded-lg mx-3">
                    <table className="table table-borderless table-sm table-striped table-hover mb-0">
                      <thead>
                        <tr className="form-group">
                          <td className="col-4 form-label text-center border-right">Unit</td>
                          <td className="col-4 form-label text-center border-right">Capacity</td>
                          <td className="col-4 form-label text-center">Number of Units</td>
                        </tr>
                      </thead>
                      <tbody>
                        {item.quantity_matrix.map((quantityMatrixItem) => {
                          const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                          return (
                            <tr key={quantityMatrixMultiplier} className="border-top form-group">
                              <td className="col-4 text-left form-label border-right">
                                {_.get(quantityMatrixItem, 'unit')}
                              </td>
                              <td className="col-4 text-left form-label border-right">
                                {_.get(quantityMatrixItem, 'capacity')}
                              </td>
                              <td className="col-4 text-left form-label">
                                <input
                                  className="form-control"
                                  type="text"
                                  name={quantityMatrixMultiplier}
                                  onChange={onChangeQuantityMatrix}
                                  value={_.get(
                                    formDataQuantityMatrix,
                                    `${quantityMatrixMultiplier}`,
                                    ''
                                  )}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              )
            })
            
          ) : (
            ''
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={creating || !validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateRangeModal.propTypes = {
  newBusinessesId: PropTypes.string.isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  createNewBusinessActivities: PropTypes.instanceOf(Function).isRequired,

  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,

  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_NEW_BUSINESS_ACTIVITIES) > -1,
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateRangeModal);
